import _Tooltip from "@mui/material/Tooltip";
import _IconButton from "@mui/material/IconButton";
import _Update from "@mui/icons-material/Update";
import _Grid from "@mui/material/Grid";
import _Typography from "@mui/material/Typography";
import { red } from '@mui/material/colors';
import React, { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useCancellablePromise } from '../hooks/cancellable-promise';
import { BikeStationService } from '../services';
function BikeStationAvailabilities({
  bikeStation: {
    id,
    availableClassicBikes,
    availableEBikes,
    availableLots
  },
  enqueueSnackbar,
  onUpdated,
  setBikeStation,
  setHistory
}) {
  const {
    t
  } = useTranslation();
  const {
    cancellablePromise,
    cancelPromises
  } = useCancellablePromise();
  useEffect(() => {
    update();
    return () => cancelPromises();
  }, []);
  async function update() {
    cancelPromises();
    setHistory(undefined);
    try {
      const _bikeStation = await cancellablePromise(BikeStationService.getBikeStation(id, {
        history: true
      }));
      setHistory(_bikeStation.history?.reverse());
      setBikeStation(_bikeStation);
      return _bikeStation;
    } catch (err) {
      if (!(err instanceof Error) || err?.name !== 'CancelledPromiseError') {
        console.error(err);
        enqueueSnackbar?.(t('commons.bike_stations.refresh_error'));
      }
      throw err;
    }
  }
  async function refresh() {
    try {
      const _bikeStation = await update();
      onUpdated?.(_bikeStation);
    } catch (err) {
      console.error(err);
    }
  }
  return /*#__PURE__*/React.createElement(_Grid, {
    container: true,
    spacing: 2,
    sx: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(_Grid, {
    display: "flex",
    flexDirection: "column",
    size: 3
  }, /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.bike_stations.bikes"
  })), /*#__PURE__*/React.createElement(_Typography, {
    color: availableClassicBikes < 5 ? red[500] : 'inherit',
    variant: "h6"
  }, availableClassicBikes)), /*#__PURE__*/React.createElement(_Grid, {
    display: "flex",
    flexDirection: "column",
    size: 5
  }, /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.bike_stations.e-bikes"
  })), /*#__PURE__*/React.createElement(_Typography, {
    color: availableEBikes < 5 ? red[500] : 'inherit',
    variant: "h6"
  }, availableEBikes)), /*#__PURE__*/React.createElement(_Grid, {
    display: "flex",
    flexDirection: "column",
    size: 3
  }, /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.bike_stations.slots"
  })), /*#__PURE__*/React.createElement(_Typography, {
    color: availableLots < 5 ? red[500] : 'inherit',
    variant: "h6"
  }, availableLots)), /*#__PURE__*/React.createElement(_Grid, {
    alignItems: "flex-end",
    display: "flex",
    flexDirection: "column",
    size: 1
  }, /*#__PURE__*/React.createElement(_Tooltip, {
    placement: "left",
    title: /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "commons.bike_stations.actions.refresh_availabilities"
    })
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(_IconButton, {
    onClick: refresh,
    size: "small"
  }, /*#__PURE__*/React.createElement(_Update, null))))));
}
export default BikeStationAvailabilities;